export interface AdjustmentStudio {
    item: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentStudioProps {
    item: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentStudio = (obj: ObjectToAdjustmentStudioProps): AdjustmentStudio => {
    return {
        item: obj.item,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}